// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2Xpq9","hasMenu":"styles__hasMenu___3EYPD","rotate":"styles__rotate___33UA_","fadein":"styles__fadein___2MJai","slideFromRight":"styles__slideFromRight___hNd2g","waves":"styles__waves___yjRNh"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/Container/styles.scss
// module id = ./resources/assets/js/containers/Container/styles.scss
// module chunks = 0